<template>
  <span
    :class="handleClass"
    class="sIcon material-symbols-rounded"
    :style="{ fontSize: size, cursor: cursor }"
    :disabled="disabled"
  >
    {{ icon }}
  </span>
</template>

<script lang="ts" setup>
interface IProps {
  icon: string;
  disabled?: boolean;
  size?: string;
  cursor?: string;
  type?:
    | "default"
    | "primary"
    | "secondary"
    | "danger"
    | "info"
    | "success"
    | "warning";
}
import { computed } from 'vue'
const props = withDefaults(defineProps<IProps>(), {
  type: "default",
  cursor: "inherit"
});
const handleClass = computed(() => ({
  "sIcon--primary": props.type === "primary",
  "sIcon--secondary": props.type === "secondary",
  "sIcon--danger": props.type === "danger",
  "sIcon--info": props.type === "info",
  "sIcon--success": props.type === "success",
  "sIcon--warning": props.type === "warning",
  "sIcon--disabled": props.disabled
}));
</script>

<style lang="scss">
.sIcon {
  &--default {
    color: _map.get($map: $neutro, $key: 500);
  }
  &--default:hover {
    color: _map.get($map: $neutro, $key: 100);
  }

  &--disabled {
    color: _map.get($map: $neutro, $key: 200) !important;
  }

  &--primary {
    color: _map.get($map: $azulPrincipal, $key: 500);
  }
  &--primary:hover {
    color: _map.get($map: $azulPrincipal, $key: 400);
  }
  &--secondary {
    color: _map.get($map: $neutro, $key: 500);
  }
  &--secondary:hover {
    color: _map.get($map: $neutro, $key: 400);
  }
  &--danger {
    color: _map.get($map: $vermelho, $key: 500);
  }
  &--danger:hover {
    color: _map.get($map: $vermelho, $key: 400);
  }
  &--info {
    color: _map.get($map: $azulPrincipal, $key: 500);
  }
  &--info:hover {
    color: _map.get($map: $azulPrincipal, $key: 400);
  }
  &--success {
    color: _map.get($map: $verde, $key: 500);
  }
  &--success:hover {
    color: _map.get($map: $verde, $key: 400);
  }
  &--warning {
    color: _map.get($map: $amarelo, $key: 500);
  }
  &--warning:hover {
    color: _map.get($map: $amarelo, $key: 400);
  }
}
</style>
